import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.keys";
export var isFilterable = function isFilterable(filter) {
  return typeof filter.filterable === 'boolean' ? filter.filterable : true;
};
export var getFilterableTagIds = function getFilterableTagIds(filters) {
  var filterId = Object.keys(filters);
  return filterId.filter(function (id) {
    return filters[id].filterable;
  });
};